"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalFonts = void 0;
var GlobalFonts = {
  ':root': {
    '--Link-Blue-120': '#017cbf',
    '--Link-Blue-80': '#35b0f2',
    '--Link-Blue-100': '#029cef',
    '--Chambray-120': '#283663',
    '--Chambray-80': '#5c6996',
    '--Chambray-100': '#33447c',
    '--Chambray-50': '#99a1bd',
    '--Chambray-20': '#d6dae5',
    '--Chambray-10': '#eaecf1',
    '--Sunflower-120': '#c3a72c',
    '--Sunflower-80': '#f6da60',
    '--Sunflower-100': '#f4d138',
    '--Sunflower-50': '#f9e89b',
    '--Sunflower-20': '#fdf6d7',
    '--Sunflower-10': '#fdfaeb',
    '--Timber-Wolf-120': '#aeaaa5',
    '--Timber-Wolf-80': '#e1ddd9',
    '--Timber-Wolf-100': '#dad5cf',
    '--Timber-Wolf-50': '#eceae7',
    '--Timber-Wolf-20': '#f3f1ee',
    '--Fruit-Salad-120': '#3b783b',
    '--Fruit-Salad-100': '#4a974a',
    '--Fruit-Salad-80': '#6eac6e',
    '--Fruit-Salad-50': '#a4cba4',
    '--Fruit-Salad-20': '#dbeadb',
    '--Fruit-Salad-10': '#ecf4ec',
    '--Fern-120': '#58ac6e',
    '--Fern-80': '#8cdfa1',
    '--Fern-100': '#6fd78a',
    '--Fern-50': '#b7ebc4',
    '--Fern-20': '#e2f7e8',
    '--Fern-10': '#f0fbf3',
    '--Mountain-Meadow-120': '#107a70',
    '--Mountain-Meadow-80': '#44ada3',
    '--Mountain-Meadow-100': '#15998c',
    '--Mountain-Meadow-50': '#8accc5',
    '--Mountain-Meadow-20': '#d0ebe8',
    '--Mountain-Meadow-10': '#e7f4f3',
    '--OG-Teal-120': '#099893',
    '--OG-Teal-80': '#3dcbc6',
    '--OG-Teal-100': '#0cbeb8',
    '--OG-Teal-50': '#85dedb',
    '--OG-Teal-20': '#cef2f1',
    '--OG-Teal-10': '#e6f8f7',
    '--Brick-Red-120': '#a62835',
    '--Brick-Red-80': '#da5b69',
    '--Brick-Red-100': '#d03243',
    '--Brick-Red-50': '#e798a1',
    '--Brick-Red-20': '#f6d6d9',
    '--Brick-Red-10': '#fceff0',
    '--Tundora-100': '#4a4a4a',
    '--Tundora-50': '#9b9b9b',
    '--Tundora-20': '#dddddd',
    '--Tundora-10': '#f6f6f6',
    '--Tundora-05': '#fafafa',
    '--White': '#ffffff',
    '--California-Poppy-100': '#e1813d'
  },

  /* Text styles */
  '.H1-Chambray': {
    fontFamily: 'Lato !important',
    fontSize: '48px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.17 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.H1-Dark': {
    fontFamily: 'Lato !important',
    fontSize: '48px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.17 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.H1-Light': {
    fontFamily: 'Lato !important',
    fontSize: '48px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.17 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.H1-White': {
    fontFamily: 'Lato !important',
    fontSize: '48px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.17 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.H2-Chambray': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.H2-Dark': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.H2-Light': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.H2-White': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.KPI-Large-Dark': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.31 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.KPI-Large-Warning': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.31 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.KPI-Large-White': {
    fontFamily: 'Lato !important',
    fontSize: '32px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.31 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.KPI-Small-Dark': {
    fontFamily: 'Lato !important',
    fontSize: '28px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.KPI-Small-Warning': {
    fontFamily: 'Lato !important',
    fontSize: '28px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.KPI-Small-White': {
    fontFamily: 'Lato !important',
    fontSize: '28px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.H3-Chambray': {
    fontFamily: 'Lato !important',
    fontSize: '24px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.H3-Dark': {
    fontFamily: 'Lato !important',
    fontSize: '24px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.H3-Light': {
    fontFamily: 'Lato !important',
    fontSize: '24px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.H3-White': {
    fontFamily: 'Lato !important',
    fontSize: '24px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.H4-Chambray': {
    fontFamily: 'Lato !important',
    fontSize: '20px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: 'normal !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.H4-Dark': {
    fontFamily: 'Lato !important',
    fontSize: '20px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: 'normal !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.H4-Dark-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '20px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: 'normal !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.H4-Light': {
    fontFamily: 'Lato !important',
    fontSize: '20px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: 'normal !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.H4-White': {
    fontFamily: 'Lato !important',
    fontSize: '20px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: 'normal !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Body-Medium-Inactive': {
    fontFamily: 'Lato !important',
    fontSize: '18px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Medium-Static': {
    fontFamily: 'Lato !important',
    fontSize: '18px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Body-Medium-White': {
    fontFamily: 'Lato !important',
    fontSize: '18px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Body-Medium-Link': {
    fontFamily: 'Lato !important',
    fontSize: '18px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: '#029cef !important'
  },
  '.Body-Medium-Link-Disabled': {
    fontFamily: 'Lato !important',
    fontSize: '18px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: '#9b9b9b !important'
  },
  '.Body-Regular-Center-ALL-CAP-LINK-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Regular-Center-Chambray-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Chambray-100) !important'
  },
  '.Body-Regular-Center-Error-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Body-Regular-Center-Inactive-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Regular-Center-Link-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Regular-Center-Static-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Body-Regular-Center-Success-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Body-Regular-Center-White-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: '#ffffff !important'
  },
  '.Body-Regular-Left-ALL-CAP-LINK-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Regular-Left-Chambray-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.Body-Regular-Left-Error-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Body-Regular-Left-Warning-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Sunflower-120) !important'
  },
  '.Body-Regular-Left-Inactive-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Regular-Left-Link-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Regular-Left-Static-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Body-Regular-Left-Success-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Body-Regular-Left-White-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Body-Regular-Center-Chambray': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Chambray-100) !important'
  },
  '.Body-Regular-Center-Error': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Body-Regular-Center-Inactive': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Regular-Center-Link': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Regular-Center-Static': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Body-Regular-Center-Success': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Body-Regular-Center-White': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'center !important',
    color: '#ffffff !important'
  },
  '.Body-Regular-Left-Chambray': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.Body-Regular-Left-Error': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Body-Regular-Left-Inactive': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Regular-Left-Link': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Regular-Left-Static': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Body-Regular-Left-Success': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Body-Regular-Left-White': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.5 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Tables-Numerical-Link': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '3.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'right !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Tables-Numerical-Negative': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    textAlign: 'right !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Tables-Numerical-Positive': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.25 !important',
    letterSpacing: 'normal !important',
    textAlign: 'right !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Tables-Numerical-Static': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '3.5 !important',
    letterSpacing: 'normal !important',
    textAlign: 'right !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Tables-Textual': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '3.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Tables-Textual-Disabled': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '3.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Tables-Textual-Link': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '3.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Tables-Textual-Static': {
    fontFamily: 'Lato !important',
    fontSize: '16px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '3.5 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Subcopy-Italic-Error': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'italic !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Subcopy-Italic-Link': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'italic !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Subcopy-Italic-Static': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'italic !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Subcopy-Italic-Success': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'italic !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Subcopy-Italic-White': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'italic !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Subcopy-Error': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Subcopy-Link': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Subcopy-Static-Alt': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Subcopy-Static': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Subcopy-Success': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Subcopy-White': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Label-Input-Active': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Chambray-100) !important'
  },
  '.Label-Input-Error': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Label-Input-Set': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Label-Table-Left-Active': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Label-Table-Left-Static': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '32px !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Label-Table-Right-Active': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    textAlign: 'right !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Label-Table-Right-Static': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    textAlign: 'right !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Small-Inactive': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-50) !important'
  },
  '.Body-Small-Link': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Small-Static': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Body-Small-White': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: '#ffffff !important'
  },
  '.Subcopy-Regular-Link': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Link-Blue-100) !important'
  },
  '.Body-Small-Success': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Fruit-Salad-100) !important'
  },
  '.Body-Small-Error': {
    fontFamily: 'Lato !important',
    fontSize: '12px !important',
    fontWeight: 'normal !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.33 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Brick-Red-100) !important'
  },
  '.Text-Uppercase': {
    textTransform: 'uppercase'
  },
  '.Text-Pointer': {
    cursor: 'pointer'
  },
  '.Text-Pointer-NotAllowed': {
    cursor: 'not-allowed'
  },
  '.Pointer-Events-None': {
    pointerEvents: 'none'
  },
  '.Lato-Bold': {
    fontFamily: 'Lato !important',
    fontSize: '14px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    fontStretch: 'normal !important',
    lineHeight: '1.29 !important',
    letterSpacing: 'normal !important',
    color: 'var(--Tundora-100) !important'
  },
  '.Text-Capitalize': {
    textTransform: 'capitalize'
  },
  '.MuiButton-root.Button-Link, .MuiButtonBase-root.Button-Link': {
    color: 'var(--Link-Blue-100)',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  '.No-Shadow': {
    boxShadow: 'none !important'
  }
};
exports.GlobalFonts = GlobalFonts;